export default __webpack_public_path__ + "static/media/boldt_flavours_logo.5aa050dc.jpg";